import Release from 'components/framework/models/Release';
import RecordFields from '../RecordFields';
import { registerRecordFieldsClasses } from './index';

export default class ReleaseFields extends RecordFields {
  static modelClass = Release;
}

registerRecordFieldsClasses({ ReleaseFields });
